"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batch_update_elements = void 0;
const api_1 = require("../../api");
const store_1 = require("../../../store");
const batch_update_elements = (data, loader = true) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { userState } = store_1.redux_store.getState();
    const { token } = userState;
    // Batch update for draft documents
    const response = yield new api_1.API().apiPost({
        baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
        endpoint: `draft/batch-update-elements`,
        content: data,
        loader: loader,
        authorization: `${token}`,
    });
    return response;
});
exports.batch_update_elements = batch_update_elements;
